<template>
	<el-dialog title="添加用户" width="550px" v-model="data.dialogTableVisible">
		<el-form
			label-width="90px"
			:model="data.formLabelAlign"
			:rules="data.rules"
			ref="formRef"
		>
			<el-form-item label="账号" prop="userName">
				<el-input
					v-model="data.formLabelAlign.userName"
					placeholder="请输入账号"
				></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="password" v-if="scene === 'add'">
				<el-input
					v-model="data.formLabelAlign.password"
					placeholder="请输入密码"
				></el-input>
			</el-form-item>
			<el-form-item label="姓名" prop="chineseName">
				<el-input
					v-model="data.formLabelAlign.chineseName"
					placeholder="请输入姓名"
				></el-input>
			</el-form-item>
			<el-form-item label="角色">
				<el-select
					style="width: 100%"
					v-model="data.roleId"
					placeholder="请选择角色"
				>
					<el-option
						v-for="item in roleList"
						:key="item.id"
						:label="item.roleName"
						:value="item.id"
					>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="手机号" prop="phone">
				<el-input
					v-model="data.formLabelAlign.phone"
					placeholder="请输入手机号"
				></el-input>
			</el-form-item>
			<el-form-item label="状态" v-if="scene === 'edit'">
				<el-radio-group v-model="data.isDelete">
					<el-radio :label="0">正常</el-radio>
					<el-radio :label="1">停用</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="备注">
				<el-input
					v-model="data.formLabelAlign.remark"
					placeholder="请输入备注"
					type="textarea"
					:autosize="{ minRows: 2, maxRows: 4 }"
				></el-input>
			</el-form-item>
		</el-form>
		<footer class="tac" style="margin-top: 50px">
			<el-button @click="handleCancle">取消</el-button>
			<el-button type="primary" @click="handleSave">确定</el-button>
		</footer>
	</el-dialog>
</template>

<script>
import { defineComponent, inject, onMounted, reactive, ref } from "vue";
import {
	apiSysUserInsert,
	apiSysUserRoleInsert,
	apiSysUserUpdate,
} from "@/api/requestApis.js";
export default defineComponent({
	props: {
		scene: {
			type: String,
			default: "add",
		},
		currentData: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props) {
		const handleUpdateTable = inject("handleUpdateTable");
		const roleList = inject("roleList");
		const formRef = ref("");
		const data = reactive({
			roleList: [],
			dialogTableVisible: false,
			roleId: "",
			isDelete: 0,
			rules: {
				userName: [
					{ required: true, message: "请输入账号", trigger: "blur" },
				],
				password: [
					{ required: true, message: "请输入密码", trigger: "blur" },
				],
				chineseName: [
					{ required: true, message: "请输入姓名", trigger: "blur" },
				],
				phone: [
					{
						required: true,
						message: "请输入手机号",
						trigger: "blur",
					},
				],
			},
			formLabelAlign: {
				userName: "",
				password: "",
				chineseName: "",
				phone: "",
				remark: "",
			},
		});

		const handleReset = () => {
			data.roleId = "";
			data.isDelete = 0;
			Object.keys(data.formLabelAlign).forEach((key) => {
				data.formLabelAlign[key] = "";
			});
		};

		const handleToggle = (val) => {
			data.dialogTableVisible = val;
			if (val && props.scene === "edit") {
				handleSetDefaultValue();
			}
		};
		const handleSave = () => {
			formRef.value.validate(async (valid) => {
				if (valid) {
					if (props.scene === "add") {
						const userId = await apiSysUserInsert(
							data.formLabelAlign
						);
						await apiSysUserRoleInsert({
							userId,
							roleId: data.roleId,
						});
					}

					if (props.scene === "edit") {
                        // 创建一个不包含password的表单数据副本
                        const formData = { ...data.formLabelAlign };
                        delete formData.password;

                        await apiSysUserUpdate({
                            isDelete: data.isDelete,
                            id: props.currentData.id,
                            ...formData,
                        });
                    }


					handleToggle(false);
					handleReset();
					handleUpdateTable();
				}
			});
		};

		const handleCancle = () => {
			handleToggle(false);
			handleReset();
		};

		const handleSetDefaultValue = () => {
			setTimeout(() => {
				console.log("props.currentData:", props.currentData);
				data.formLabelAlign.userName = props.currentData.userName;
				// data.formLabelAlign.password = props.currentData.password;
				data.formLabelAlign.chineseName = props.currentData.chineseName;
				data.formLabelAlign.phone = props.currentData.phone;
				data.formLabelAlign.remark = props.currentData.remark;
				data.isDelete = Number(props.currentData.isDelete);
				data.roleId = Number(props.currentData.roleId);
			});
		};

		onMounted(async () => {});
		return {
			formRef,
			roleList,
			handleCancle,
			handleSave,
			handleToggle,
			data,
		};
	},
});
</script>

<style scoped>
</style>
